<template>
  <div class="btn_group type2">
    <div>
      <mpn-basic-button
        v-if="!hasOneButton"
        :hide-on-mobile="!showOnMobile"
        :disabled="disabledLeft"
        @click="$emit('click-left')"
      >
        {{ computedTitleLeft }}
      </mpn-basic-button>
      <mpn-basic-button
        :color="computedColorRight"
        :hide-on-mobile="!showOnMobile"
        :disabled="computedDisabledRight"
        @click="$emit('click-right');$emit('click')"
      >
        {{ computedTitleRight }}
      </mpn-basic-button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'MainButtonGroup',
  components: {
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    titleLeft: {
      type: String,
      default: null,
    },
    titleRight: {
      type: String,
      default: null,
    },

    color: {
      type: String,
      default: 'white',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    disabledLeft: {
      type: Boolean,
      default: false,
    },
    disabledRight: {
      type: Boolean,
      default: false,
    },
    showOnMobile: {
      type: Boolean,
      default: false,
    },

  },
  computed: {
    hasOneButton() {
      if (!this.titleRight && this.title !== null) {
        return true;
      }
      return false;
    },
    computedTitleRight() {
      if (this.titleRight) {
        return this.titleRight;
      }
      return this.title;
    },
    computedTitleLeft() {
      return this.titleLeft ? this.titleLeft : 'Click me';
    },
    computedDisabledRight() {
      if (this.hasOneButton) {
        return this.disabled;
      }
      return this.disabledRight;
    },
    computedColorRight() {
      if (this.hasOneButton) {
        return this.color;
      }
      return 'navy';
    },
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MainButtonGroup.vue